module.exports = __webpack_public_path__ + "img/calendar.4e19f0c4.svg";